"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Box = _interopRequireDefault(require("@gogame/ui/Box"));
var _Chip = _interopRequireDefault(require("@gogame/ui/Chip"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PresentedRows = function PresentedRows(_ref) {
  var presentedRows = _ref.presentedRows,
    onClearPresentedRows = _ref.onClearPresentedRows;
  if (!(presentedRows !== null && presentedRows !== void 0 && presentedRows.length)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
  }
  var label = (presentedRows === null || presentedRows === void 0 ? void 0 : presentedRows.length) > 1 ? "".concat(presentedRows.length, " rows are presented only") : (presentedRows === null || presentedRows === void 0 ? void 0 : presentedRows.length) === 1 ? '1 row is presented' : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
    mr: 2,
    ml: 2,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip["default"], {
      label: label,
      onDelete: onClearPresentedRows,
      removable: true
    })
  });
};
var _default = exports["default"] = PresentedRows;